// extracted by mini-css-extract-plugin
export default {"vaccination":"static-React-Applications-Vaccination-___index-module__vaccination","card":"static-React-Applications-Vaccination-___index-module__card"};